<template>
	<div class="BlackList">
		<a-form-model layout="inline" style="margin-top:15px;">
			<a-form-model-item label="标题">
				<a-input placeholder="请输入标题" allow-clear :maxLength="20" v-model="search.title" @keyup.enter="getBlacklist(1)"/>
			</a-form-model-item>
			<a-form-model-item label="类型">
				<a-select
					allowClear
					v-model="search.type"
					placeholder="请选择类型"
					style="width:198px;">
					<a-select-option :value="1">机构</a-select-option>
					<a-select-option :value="2">课程</a-select-option>
				</a-select>
			</a-form-model-item>
			<a-form-model-item>
				<a-button type="primary" @click="getBlacklist(1)">查询</a-button>
			</a-form-model-item>
			<a-form-model-item v-permission="'/content/GamesComment/BlackListSet'">
				<a-button type="primary" @click="add()">添加</a-button>
			</a-form-model-item>
		</a-form-model>
		<div class="table">
			<a-table
				:columns="columns"
				:scroll="{y: 350}"
				rowKey="id"
				@change="handleTableChange"
				:pagination="tableRelevant.tablePagination"
				:loading="tableRelevant.tableLoading"
				:dataSource="tableRelevant.tableDataSource">
				<div slot="type" slot-scope="text">
					{{ text.type == 1 ? '机构' : '课程' }}
				</div>
				<div slot="str" slot-scope="text">
					{{ text.keys.join('、') }}
				</div>
				<div slot="action" slot-scope="text" >
					<a v-permission="'/content/GamesComment/BlackListSet'" @click="edit(text)">编辑</a>
					<a-popconfirm title="确定删除？" @confirm="isDelete(text)">
						<a style="color:#f00;margin-left: 15px;">删除</a>
					</a-popconfirm>
				</div>
			</a-table>
		</div>
	</div>
</template>

<script>
import {tableRelevant} from "@/pages/projectImpl/js/utils";
const columns = [
	{title: '标题',dataIndex: 'title'},
	{title: '类型',scopedSlots: { customRender: 'type' }},
	{title: '对象',scopedSlots: { customRender: 'str' }},
	{title: '更新时间',dataIndex: 'updateTime'},
	{title: '操作',scopedSlots: { customRender: 'action' }},
]
export default {
	name:'BlackList',
	data() {
		return {
			search:{
				title:undefined,
				type:undefined
			},
			columns,
			tableRelevant: tableRelevant.call(this,this.getBlacklist),
		}
	},
	mounted(){
		this.getBlacklist(1)
	},
	methods:{
		clearSearch(){
			this.search = {
				title:undefined,
				type:undefined
			}
			this.getBlacklist(1)
		},
		handleTableChange(){

		},
		add(){
			this.$router.push({
				path:'/content/GamesComment/BlackListSet',
				query:{
					type:'add'
				}
			})
		},
		edit(text){
			this.$router.push({
				path:'/content/GamesComment/BlackListSet',
				query:{
					type:'edit',
					id:text.id
				}
			})
			localStorage.setItem('BlackText',JSON.stringify(text));
		},
		isDelete(text){
			let formData = new FormData();
			formData.append('ids',[text.id])
			this.$http.GamesComment.deleteBlacklist(formData)
			.then(res =>{
				const {status, data, message} = res;
					this.$message.success('操作成功');
					this.getBlacklist(1);
				
			})
		},

		getBlacklist(pageIndex){
			let params = {
				pageIndex:pageIndex || this.tableRelevant.tablePagination.current,
				pageSize:this.tableRelevant.tablePagination.pageSize,
				...this.search
			}
			this.$http.GamesComment.getBlacklist(params)
			.then(res =>{
                const {status, data, message} = res;
					data.items.forEach(v =>{
						v.ids = Object.keys(v.names);
						v.keys = Object.values(v.names);
					})
                    this.tableRelevant.tableDataSource = data.items;
					this.tableRelevant.tablePagination.total = data.totalCount;
                    this.tableRelevant.tablePagination.current = data.pageIndex;
              
			})
		},
	}
}
</script>

<style>
.table{
	margin-top: 15px;
}
</style>
